module.exports = __webpack_public_path__ + "img/3-2.c9250a7d.jpg";